import { render, staticRenderFns } from "./FpvTest.vue?vue&type=template&id=56312c47"
import script from "./FpvTest.vue?vue&type=script&lang=js"
export * from "./FpvTest.vue?vue&type=script&lang=js"
import style0 from "./FpvTest.vue?vue&type=style&index=0&id=56312c47&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports